module.exports = __webpack_public_path__ + "csd-66bfec2e.webp";